module.exports = "/_next/static/images/c8ecb1b16318a8a4a8dd8c9ac19900c4-nubank-outdoor-xs@2x.jpg";